import axios from 'axios';
import apiConfig from '../api.config';

export default function policeReportCheckS3Connection(data) {
  const {
    host,
    URIs: { policeReportCheckS3Connection },
  } = apiConfig;

  const uri = `${host}${policeReportCheckS3Connection}`;

  return axios
    .post(uri, data)
    .then(res => {
      return res.data;
    });
}
